import React, { useState } from 'react';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import ViewReverse from '../../components/ViewReverse';
import ticketingHistoryFunctional from './index.function';
import { ticketingHistoryData } from '../../config/config';
import Button from '../../components/Button';
import LoaderModal from '../../components/LoaderModal';
import ViewItems from '../../components/ViewItems';

const TicketingHistory = () => {
  const {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    direction,
    ticketing_history,
    ticketing_history_loading,
  } = ticketingHistoryFunctional();

  return (
    <div className='min-h-full'>
      <ViewReverse className='justify-between items-center flex-wrap'>
        <ViewReverse className='gap-5 items-center'>
          <ReactSVG
            src={icons?.backSmall}
            className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`}
            onClick={() => navigate(-1)}
          />
          <Text
            text={getContentKey('view_history_heading')}
            color='text-black'
            size={fontSizes.h18}
            weight={TextWeight.bold}
          />
        </ViewReverse>
        <Button
          text={getContentKey('create_support_history')}
          bgColor='bg-primary'
          className={'w-36 text-center capitalize'}
          onClick={() => navigate('/help/contact')}
        />
      </ViewReverse>
      <div
        dir={direction}
        className='border border-grey rounded-xl mt-8 py-3 px-5 grid grid-cols-1 md:grid-cols-2 gap-5 shadow-light'
      >
        {ticketing_history?.length > 0 ? (
          ticketing_history?.map((item, index) => (
            <div
              key={index}
              className='border border-grey rounded-xl w-full py-3 px-4'
            >
              <Text
                text={item?.displayTicketId}
                color='text-black'
                isTruncate={false}
                size={fontSizes.h16}
                weight={TextWeight.semiBold}
              />
              <ViewReverse className={'flex-col gap-1 my-2'}>
                <Text
                  text={getContentKey('subject')}
                  color='text-black'
                  size={fontSizes.h12}
                  weight={TextWeight.medium}
                />
                <Text
                  text={item?.subject}
                  isTruncate={false}
                  color='text-primary'
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              <ViewReverse className={'flex-col gap-1 my-2'}>
                <Text
                  text={getContentKey('request_type')}
                  color='text-black'
                  size={fontSizes.h12}
                  weight={TextWeight.medium}
                />
                <Text
                  text={item?.requestType}
                  color='text-primary'
                  isTruncate={false}
                  size={fontSizes.h14}
                  weight={TextWeight.semiBold}
                />
              </ViewReverse>
              <div className='flex justify-between items-center'>
                <ViewReverse className={'flex-col gap-1'}>
                  <Text
                    text={getContentKey('date')}
                    color='text-black'
                    size={fontSizes.h12}
                    weight={TextWeight.medium}
                  />
                  <Text
                    text={new Date(item?.createdDate)?.toLocaleDateString(
                      'en-GB'
                    )}
                    isTruncate={false}
                    color='text-primary'
                    size={fontSizes.h14}
                    weight={TextWeight.semiBold}
                  />
                </ViewReverse>
                <ViewReverse className={'flex-col gap-1'}>
                  <Text
                    text={getContentKey('status')}
                    color='text-black'
                    align={isArabic ? 'text-left' : 'text-right'}
                    size={fontSizes.h12}
                    weight={TextWeight.medium}
                  />
                  <Text
                    text={item?.status}
                    color='text-primary'
                    isTruncate={false}
                    align={isArabic ? 'text-left' : 'text-right'}
                    size={fontSizes.h14}
                    weight={TextWeight.semiBold}
                  />
                </ViewReverse>
              </div>
              {item?.solutionDescription?.length > 0 && (
                <div className='flex justify-start items-center mt-2'>
                  <ViewItems className={'flex-col gap-1'}>
                    <Text
                      text={getContentKey('solution_description')}
                      color='text-black'
                      size={fontSizes.h12}
                      weight={TextWeight.medium}
                    />
                    <Text
                      text={item?.solutionDescription}
                      isTruncate={false}
                      color='text-primary'
                      size={fontSizes.h14}
                      weight={TextWeight.semiBold}
                    />
                  </ViewItems>
                </div>
              )}
            </div>
          ))
        ) : (
          <Text
            text={getContentKey('no_ticket_available')}
            color='text-black'
            size={fontSizes.h12}
            weight={TextWeight.medium}
          />
        )}
      </div>
      <LoaderModal open={ticketing_history_loading} />
    </div>
  );
};

export default TicketingHistory;
